// extracted by mini-css-extract-plugin
export default {"item":"lz4pLXfW6YQIWcFEJ8Cm"};